import React from 'react';
import * as S from './styled';
export const PageLayout = ({ leftContent, rightContent, bottomContent, bottomContentMargin = 'large', size = 'medium', children, }) => (React.createElement(S.Container, { "$size": size },
    children,
    (leftContent || rightContent) && (React.createElement(S.InnerContainer, null,
        React.createElement(S.LeftContent, null, leftContent),
        React.createElement(S.RightContent, { "data-testid": "rightPanel" }, rightContent))),
    bottomContent && (React.createElement(S.BottomContent, { "$margin": bottomContentMargin }, bottomContent))));
